import { FlowType } from '../../types'

export const flowFactory = async (flow: FlowType) => {
  switch (flow) {
    case FlowType.PREENROLL: {
      const { V3Flow } = await import(
        /* webpackChunkName: "v3_flow" */ './v3Flow'
      )
      return new V3Flow()
    }
    case FlowType.REDIRECT: {
      const { RedirectFlow } = await import(
        /* webpackChunkName: "redirect_flow" */ './redirectFlow'
      )
      return new RedirectFlow()
    }
    case FlowType.HPID: {
      const { HpidFlow } = await import(
        /* webpackChunkName: "hpid_flow" */ './hpidFlow'
      )
      return new HpidFlow()
    }
    case FlowType.OOBE_TEST_SETUP: {
      const { OobeTestSetupFlow } = await import(
        /* webpackChunkName: "oobe_test_setup_flow" */ './oobeTestSetupFlow'
      )
      return new OobeTestSetupFlow()
    }
    case FlowType.OOBE_VALUE_PROP: {
      const { OobeValuePropFlow } = await import(
        /* webpackChunkName: "oobe_value_prop_flow" */ './oobeValuePropFlow'
      )
      return new OobeValuePropFlow()
    }
    case FlowType.OOBE_ENROLL: {
      const { OobeFlow } = await import(
        /* webpackChunkName: "oobe_flow" */ './oobeFlow'
      )
      return new OobeFlow()
    }
    case FlowType.OOBE_EXIT: {
      const { OobeExitFlow } = await import(
        /* webpackChunkName: "oobe_exit_flow" */ './oobeExitFlow'
      )
      return new OobeExitFlow()
    }
    case FlowType.OOBE_SIGN_IN: {
      const { OobeSignInFlow } = await import(
        /* webpackChunkName: "oobe_sign_in_flow" */ './oobeSignInFlow'
      )
      return new OobeSignInFlow()
    }
    case FlowType.FTM: {
      const { FlipConversionFlow } = await import(
        /* webpackChunkName: "ftm_flow" */ './flipConversionFlow'
      )
      return new FlipConversionFlow()
    }
    case FlowType.SMB:
    default: {
      const { SmbFlow } = await import(
        /* webpackChunkName: "smb_flow" */ './smbFlow'
      )
      return new SmbFlow()
    }
  }
}
